// Third-party imports
import { useMutation } from "@tanstack/react-query";

import { LoginInput, RegisterInput } from "@/types/auth.types";
import { AuthResponse } from "../services/auth.service";
import { api } from "@/lib/axios";
// import { AxiosResponse } from "axios";

// Shared error handler for auth mutations
const handleAuthError = (error: unknown, action: string): AuthResponse => {
  console.error(`${action} error:`, error);
  return {
    success: false,
    error: error instanceof Error ? error.message : `${action} failed`,
  };
};

// Shared response handler for auth mutations
// const handleAuthResponse = async (
//   response: AxiosResponse
// ): Promise<AuthResponse> => {
//   const data = await response.data();

//   if (response.status !== 200) {
//     return {
//       success: false,
//       error: data.error || "Operation failed",
//     };
//   }

//   return { ...data, error: null };
// };

/**
 * Hook for user login
 */
export const useLoginUser = () => {
  return useMutation<AuthResponse, unknown, LoginInput>({
    mutationFn: async (userData: LoginInput) => {
      try {
        const response = await api.post(`/api/auth/login`, {
          ...userData,
        });

        if (response.status !== 201) {
          return {
            success: false,
            error: response.data.error || "Operation failed",
          };
        }

        return { ...response.data, error: null };
      } catch (error) {
        return handleAuthError(error, "Login");
      }
    },
  });
};

export const useRegisterUser = () => {
  return useMutation<AuthResponse, unknown, RegisterInput>({
    mutationFn: async (userData: RegisterInput) => {
      try {
        const response = await api.post(`/api/auth/register`, {
          ...userData,
        });

        console.log("RESPONSE", response);
        if (response.status !== 201) {
          return {
            success: false,
            error: response.data.error || "Operation failed",
          };
        }

        return { ...response.data, error: null };
      } catch (error) {
        console.log(error);
        return handleAuthError(error, "Registration");
      }
    },
  });
};

export const useForgotPassword = () => {
  return useMutation<AuthResponse, unknown, Omit<LoginInput, "password">>({
    mutationFn: async (userData: Omit<LoginInput, "password">) => {
      try {

        const response = await api.post(`/api/auth/forgot-password`, {
          ...userData,
        });

        if (response.status !== 200) {
          return {
            success: false,
            error: response.data.error || "Operation failed",
          };
        }

        return { ...response.data, error: null };
      } catch (error) {
        return handleAuthError(error, "Forgot Password");
      }
    },
  });
};
